import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import {
  assertSegmentIstLückenlosGefüllt,
  createMauer,
  getIstSollZwischenabstandVerbose,
  logParts,
  resetArrangement,
} from "./utils";
import { v3 } from "oc-threejs/short3";

export default {
  name: "TestRechteckFillWithElements",
};

export const testLeerbreiten: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breiten = [..._.range(0.3, 3, 0.2), 5, 10, 15, 20, 30, 100];
  for (const breite of breiten) {
    await subTestContext("Test Leerbreite " + breite + ": ", async () => {
      agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
      for (const s of agt.segmente) {
        s.parts = [];
      }
      agt.update3d();
      let i = 0;
      for (const s of agt.segmente) {
        await subTestContext("Segment index " + i + ": ", () => {
          assert.equals(breite, s.breite);
          assert.equals(0, s.parts.length);
          assert.equals(0, s.pfosten.length);
        });
        i++;
      }
    });
  }
};

export const test1mBis10mGrob: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  _.range(1, 10, 1.3).forEach((breite) => {
    agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
    for (const s of agt.segmente) {
      s.parts = [];
    }
    agt.update3d();
    agt.fillIndividuellSegmentsWithElements();
    for (const s of agt.segmente) {
      assertSegmentIstLückenlosGefüllt(s);
    }
  });
};

export const test1mIstSollDelta: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 1;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createDefaultElement();
  const delta = getIstSollZwischenabstandVerbose(s.empties[0], element);
  assert.deepEquals(
    {
      linksIst: {
        richtung: "Links",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      linksSoll: {
        richtung: "Links",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: -0.02,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
      rechtsIst: {
        richtung: "Rechts",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      rechtsSoll: {
        richtung: "Rechts",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: -0.02,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
    },
    delta
  );
};

export const test1m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 1;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
    const parts = s.getPartsAndPfosten();
    const json = logParts(s, parts);
    assert.deepEquals(
      [
        {
          x0: -0.04,
          x1: 0.04,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 0,
          breite: 0.08,
          lichteWeite: 0,
          ecke: true,
        },
        {
          x0: 0.02,
          x1: 0.98,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 0.96,
          lichteWeite: 0.92,
          ecke: false,
        },
        {
          x0: 0.96,
          x1: 1.04,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 0,
          breite: 0.08,
          lichteWeite: 0,
          ecke: true,
        },
      ],
      json
    );
  }
};

export const test10m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 10;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
    const parts = s.getPartsAndPfosten();
    const json = logParts(s, parts);
    assert.deepEquals(
      [
        {
          x0: -0.04,
          x1: 0.04,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 0,
          breite: 0.08,
          lichteWeite: 0,
          ecke: true,
        },
        {
          x0: 0.02,
          x1: 0.88,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 0.86,
          lichteWeite: 0.82,
          ecke: false,
        },
        {
          x0: 0.86,
          x1: 0.94,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 1,
          breite: 0.08,
          lichteWeite: 0,
          ecke: false,
        },
        {
          x0: 0.92,
          x1: 2.7,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 1.78,
          lichteWeite: 1.74,
          ecke: false,
        },
        {
          x0: 2.68,
          x1: 2.76,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 1,
          breite: 0.08,
          lichteWeite: 0,
          ecke: false,
        },
        {
          x0: 2.74,
          x1: 4.52,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 1.78,
          lichteWeite: 1.74,
          ecke: false,
        },
        {
          x0: 4.5,
          x1: 4.58,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 1,
          breite: 0.08,
          lichteWeite: 0,
          ecke: false,
        },
        {
          x0: 4.56,
          x1: 6.34,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 1.78,
          lichteWeite: 1.74,
          ecke: false,
        },
        {
          x0: 6.32,
          x1: 6.4,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 1,
          breite: 0.08,
          lichteWeite: 0,
          ecke: false,
        },
        {
          x0: 6.38,
          x1: 8.16,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 1.78,
          lichteWeite: 1.74,
          ecke: false,
        },
        {
          x0: 8.14,
          x1: 8.22,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 1,
          breite: 0.08,
          lichteWeite: 0,
          ecke: false,
        },
        {
          x0: 8.2,
          x1: 9.98,
          gapLinks: -0.02,
          gapRechts: -0.02,
          type: "Element",
          snap: 1,
          breite: 1.78,
          lichteWeite: 1.74,
          ecke: false,
        },
        {
          x0: 9.96,
          x1: 10.04,
          gapLinks: 0,
          gapRechts: 0,
          type: "Pfosten",
          snap: 0,
          breite: 0.08,
          lichteWeite: 0,
          ecke: true,
        },
      ],
      json
    );
  }
};

export const test3mMauerRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  createMauer({ position: v3(breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
  }
};

export const test3mMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  createMauer({ position: v3(-breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
  }
};

export const test3mMauerLinksRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  createMauer({ position: v3(-breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  createMauer({ position: v3(breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
  }
};

export const test3mMauerMitte: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  createMauer({ position: v3(0, 0, breite / 2), size: v3(1, 2, 1) });
  for (const s of agt.segmente) {
    s.parts = [];
  }
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    assertSegmentIstLückenlosGefüllt(s);
  }
};
